module.exports = "<div ng-click=\"$ctrl.setInitRanges()\" id=\"reportrange\" class=\"datepicker\" title=\"{{::'Нажмите для выбора периода' | gettext}}\"><i class=\"icon-calendar\"></i> <span class=\"hideable\">{{:: 'Период с' | gettext }} <b>{{ $ctrl.timeFrom | date: 'dd MMMM yyyy HH:mm' }} </b>{{:: 'по' | gettext }} <b>{{ $ctrl.timeTo | date: 'dd MMMM yyyy HH:mm' }}</b></span></div>"


//////////////////
// WEBPACK FOOTER
// ./src/filter/date-picker.component.html
// module id = 239
// module chunks = 0